export default {"src":"/_next/static/media/chapter-icon.91b80dae.svg","height":19,"width":18};